import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, firstValueFrom, from } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { map, mergeMap, tap } from "rxjs/operators";
import * as msal from "@azure/msal-browser";
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private msalService: MsalService,
    private auth: AuthService,
    private broadcastService: MsalBroadcastService,
    private configService: ConfigService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const url = req.url;
    console.log('calling to ' + url);

    if (url.startsWith('http://localhost:4200/assets')) {
      return next.handle(req);
    } else {
      return from(
        this.msalService.acquireTokenSilent({
          account: this.auth.getAccount(),
          redirectUri: this.configService.getEnv('fetrapiLoginRedirectURL') as string,
          scopes: [this.configService.getEnv('fetrapiWebAPIScope') as string]
        })
        .pipe(
          map((response: msal.AuthenticationResult) => {  
            // var token = response.tokenType === ServerHashParamKeys.ID_TOKEN ? response.idToken : response.accessToken;
            var token = response.accessToken;
            const authHeader = `Bearer ${token}`; 
            localStorage.setItem('jwttoken', token); 

            return req.clone({
              setHeaders: {
                Authorization: authHeader,
              }
            });
          })
        )
        .pipe(
          mergeMap(nextReq => next.handle(nextReq)),
          tap(
            event => { },
            err => {
              if (err instanceof HttpErrorResponse && err.status === 401) { 
                // this.broadcastService.broadcast("msal:notAuthorized", err.message);
              }
            }
          )
        )
      )
    }
  }

}
